"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Function to check if Safari is version 14 or below
 * @returns true when the user agent is Safari 14.x.x or below otherwise false
 */
var isSafariV14OrBelow = function isSafariV14OrBelow() {
  var _navigator$userAgent$;
  var uA = window.navigator.userAgent;
  // Regex to check Safari browser by checking if Chrome or android string is present
  var isSafari = /^((?!chrome|android).)*safari/i.test(uA);
  // Regex to check Safari version
  var safariVersion = isSafari && ((_navigator$userAgent$ = navigator.userAgent.match(/Version\/(\d+)/i)) === null || _navigator$userAgent$ === void 0 ? void 0 : _navigator$userAgent$.length) > 0 && parseFloat(navigator.userAgent.match(/Version\/(\d+)/i)[1], 10);
  if (isSafari && safariVersion < 15) return true;
  return false;
};
var _default = exports["default"] = isSafariV14OrBelow;